"use client";

import { Avatar, AvatarProps } from "@heroui/react";
import Image from "next/image";

interface OptimizedAvatarProps extends Omit<
  AvatarProps,
  "ImgComponent" | "imgProps"
> {
  /** Size in pixels for Next.js Image optimization. Defaults to 96 (2x for common avatar sizes) */
  optimizedSize?: number;
}

/**
 * OptimizedAvatar - Avatar component with Next.js Image optimization
 *
 * Uses next/image for automatic image optimization, resizing, and format conversion.
 * Falls back to HeroUI Avatar's default behavior when no src is provided.
 */
export function OptimizedAvatar({
  src,
  optimizedSize = 96,
  ...props
}: OptimizedAvatarProps) {
  if (!src) {
    return <Avatar {...props} />;
  }

  return (
    <Avatar
      {...props}
      src={src}
      ImgComponent={Image}
      imgProps={
        {
          width: optimizedSize,
          height: optimizedSize,
          unoptimized: false,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
    />
  );
}
